import type { Filters } from '@ipfabric/utils';
import type { ApiTableCommandFactory } from 'components/ApiTable/model/ApiTableModel';

interface ChangeAdvancedFilterCommand {
  filters: Filters | undefined;
}

export const changeAdvancedFilter: ApiTableCommandFactory<
  ChangeAdvancedFilterCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    draft.advancedFilter.filters = command.filters;
  });
};
